import styled from 'styled-components';

const Row = styled.div`
    margin: 0 auto;
    padding: 0 1rem;
    max-width: 1200px;
`

export default Row